export default __webpack_public_path__ + "static/media/google-icon.d5f8e107.svg";